import styles from './LayoutCard.module.css';
import * as ColorSystem from '../../styles/colors';

const LayoutCard = ({ layout, handleClickDetail }) => {
  return (
    <div className={styles.layoutCard} style={{ backgroundColor: ColorSystem.backgroundColors.lightBackground}}>
      <h2 className={styles.layoutTitle} style={{ color: ColorSystem.textColors.darkText }}>{layout.name}</h2>
      <p className={styles.layoutDescription} style={{ color: ColorSystem.textColors.secondaryText }}>{layout.description? layout.description : "No description available"}</p>
      <div className={styles.layoutActions}>
        <button style={{ backgroundColor: ColorSystem.buttonColors.darkButton, color: ColorSystem.textColors.whiteText }} onClick={() => handleClickDetail(layout._id)}>View Details</button>
      </div>
    </div>
  );
};

export default LayoutCard;
